"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const USGovernmentBanner_1 = __importDefault(require("./USGovernmentBanner"));
exports.default = USGovernmentBanner_1.default;
